import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewPayslipPage () {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const payslip = location?.state?.payslip || null

  const columns = [
    {
      header: t('name'),
      body: row => `${row.employee?.first_name || ''} ${row.employee?.last_name || ''}`
    },
    { field: 'pay_period', header: t('pay_period') },
    { field: 'payment_date', header: t('payment_date') },
    { field: 'basic_salary', header: t('basic_salary'), body: row => `${row?.basic_salary ?? 0} ${t('SAR')}` },
    { field: 'allowances', header: t('allowances'), body: row => `${row?.allowances ?? 0} ${t('SAR')}` },
    { field: 'deductions', header: t('deductions'), body: row => `${row?.deductions ?? 0} ${t('SAR')}` },
    { field: 'net_salary', header: t('net_salary'), body: row => `${row?.net_salary ?? 0} ${t('SAR')}` },
    { field: 'gosi_contribution', header: t('gosi_contribution') , body: row => `${row?.gosi_contribution ?? 0} ${t('SAR')}`}
  ]

  if (!payslip) {
    return (
      <div >
        <PageHeader title={t('Payslip Details')} onBack={() => navigate(-1)} />
        <p className='mt-4'>{t('No_payslip_selected')}</p>
        <div className='mt-4'>
          
        </div>
      </div>
    )
  }

  const data = [payslip]

  return (
    <div>
      <PageHeader title={t('Payslip Details')} onBack={() => navigate(-1)} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
